<pre>Selected: {{ selected | json }} </pre>
<pre>Favorited: {{ favorited | json }} </pre>
<app-therapist-search
  (itemClick)="onClick($event)"
  (selectionChange)="selected = $event"
  (favoriteChange)="favorited = $event">
</app-therapist-search>
